"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var actions_1 = __importDefault(require("./actions"));
exports.default = (function (virtual) {
    var ac = actions_1.default(virtual);
    return function (frame) {
        var action = frame.action, code = frame.code, desc = frame.desc;
        if (code == null || code === 200) {
            var act = ac[action];
            if (act) {
                act(frame);
            }
        }
        else {
            console.error("Error: " + action + " " + code + " " + desc);
        }
    };
});



// WEBPACK FOOTER //
// ./src/actions/receive/index.ts